
import { inject, Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { IChartCriteria, IDocument, IInBalanceCheck } from "@tylertech/tyler-api-types";

/**
 * InBalanceService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class InBalanceService {
    private readonly $apiService = inject(ApiService);
    
    GetInBalanceCheck(criteria: IChartCriteria): Promise<IInBalanceCheck> {
        return this.$apiService.sendAuth("IInBalanceService/GetInBalanceCheck", criteria);
    }
    GetRegisteredChecks(): Promise<string[]> {
        return this.$apiService.sendAuth("IInBalanceService/GetRegisteredChecks");
    }
    GetReportDocument(providerId: string): Promise<IDocument> {
        return this.$apiService.sendAuth("IInBalanceService/GetReportDocument", providerId);
    }
}
